import { createAction } from 'Utility/Redux';
import IPlayerData from '../../Player/IPlayerData';
import { fetchConflicts } from './Action/DataConflict';
import { IPlayerDataLocation } from '../../Utility/DataConflictsHelper';

export enum DataConflictsActionType {
    FETCH_CONFLICTS = 'fetchConflicts',
    START_FETCHING_CONFLICTS = 'startFetchingConflicts',
    SET_CONFLICTS = 'setConflicts',
    RESOLVE_CONFLICTS = 'resolveConflicts',
    FAILED_FETCHING_PLAYER_DATA = 'failedFetchingPlayerData',
    ACCEPT_FETCHING_PLAYER_DATA = 'acceptFailFetchingPlayerData',
}

export const DataConflictActions = {
    fetchConflicts,
    startFetchingConflicts: createAction(
        DataConflictsActionType.START_FETCHING_CONFLICTS
    ),
    setConflicts: createAction(
        DataConflictsActionType.SET_CONFLICTS,
        resolve => (data: IPlayerDataLocation[]) =>
            resolve<IPlayerDataLocation[]>(data)
    ),
    resolveConflicts: createAction(
        DataConflictsActionType.RESOLVE_CONFLICTS,
        resolve => (data: IPlayerData) => resolve<IPlayerData>(data)
    ),
    failFetchingPlayerData: createAction(
        DataConflictsActionType.FAILED_FETCHING_PLAYER_DATA
    ),
    acceptFailFetchingPlayerData: createAction(
        DataConflictsActionType.ACCEPT_FETCHING_PLAYER_DATA
    ),
};
